import classes from './PersonalDataAgreement.module.sass'
import { Helmet } from 'react-helmet-async'
import { useLegality } from '../hooks/useLegality'

const COUNTRY = process.env.REACT_APP_COUNTRY || 'ru'
const DOMAIN = COUNTRY === 'ru' ? 'ru' : COUNTRY

const text = `
СОГЛАСИЕ
на обработку персональных данных

Настоящим свободно, своей волей и в своих интересах даю согласие Ночевкину Сергею Михайловичу (далее — Оператор), находящемуся по адресу: 350016, г. Краснодар, ул. Зиповская, д. 36, номер в реестре операторов персональных данных РКН: 100340655, на автоматизированную и неавтоматизированную обработку моих персональных данных в соответствии с Политикой конфиденциальности, опубликованной по адресу https://logid.${DOMAIN}.

Цели обработки:
- создание и ведение аккаунта в веб-приложении и мобильном приложении, доступных по адресу https://logid.${DOMAIN};
- авторизация с использованием кодов подтверждения, направляемых на электронную почту;
- предоставление доступа к функциональности платформы для ведения бизнеса (сайт, мобильное приложение, CRM);
- исполнение договоров, заключенных с другими пользователями платформы по моей инициативе.

Оператор вправе осуществлять обработку моих персональных данных следующими способами: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение.

Настоящее согласие вступает в силу с момента его подтверждения в Приложении и действует до достижения целей обработки или отзыва согласия.

Согласие может быть отозвано путем направления письменного заявления на адрес Оператора, указанный выше, или на адрес электронной почты, указанный в Политике конфиденциальности.
`

export const PersonalDataAgreement = () => {
  useLegality()

  return (
    <div className={classes.TempContainer}>
      <Helmet>
        <title>logid - согласие на обработку персональных данных</title>
        <meta
          name="description"
          content="Согласие на обработку персональных данных платформы logid"
        />
      </Helmet>
      <div className={classes.Text}>{text}</div>
    </div>
  )
}
